import React, { Component, Fragment } from 'react';
import api from '../service/dadosCadastrais.service';
import { connect } from '@common/components/base.component';
import DDadosItem from '@common/components/ddados/ddados.item';
import decaSelector from '../../../store/deca.selectors';
import dadosCadastraisSelector from '../store/dadosCadastrais.selectors';
import { ddadosDadosCadastrais as DDados } from '../dadosCadastrais.ddados';
import { Row, Col } from 'react-bootstrap';
import autoBind from 'react-autobind';
import Panel from '@common/externos/components/panel/panel.component';
import CamposDinamicos from '../../camposDinamicos/container/camposdinamicos.subform';
import CpfCnpjValidator from '@common/validators/cpfCnpj.validator';
import solicitacaoSelector from '../../solicitacao/store/solicitacao.selectors';
import dadosCadastraisActions from '../store/dadosCadastrais.actions';

import contadorActions from '@/modules/mobiliario/cadastro/contador/store/contador.actions';
import Button from '@material-ui/core/Button';
import ModalContador from '@/modules/mobiliario/cadastro/contador/components/contador.modal';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      telObrigatorio: true,
      celObrigatorio: true,
    };
  }
  verificaTelefone() {
    const { dadosCadastraisSelector } = this.props;
    const { dadosCadastrais } = dadosCadastraisSelector;
    const { TelefoneCadastral } = dadosCadastrais;
    const telefone = TelefoneCadastral?.replace(/[^\d]+/g, '');
    if (telefone) {
      this.setState({ celObrigatorio: false, telObrigatorio: true });
    } else {
      this.setState({ celObrigatorio: true });
    }
  }
  verificaCelular() {
    const { dadosCadastraisSelector } = this.props;
    const { dadosCadastrais } = dadosCadastraisSelector;
    const { CelularCadastral } = dadosCadastrais;
    const celular = CelularCadastral?.replace(/[^\d]+/g, '');
    if (celular) {
      this.setState({ celObrigatorio: true, telObrigatorio: false });
    } else {
      this.setState({ telObrigatorio: true });
    }
  }

  enableRegimeTributacao(value) {
    if (!value) return false;

    return CpfCnpjValidator.validarCPF(value) || CpfCnpjValidator.validarCNPJ(value);
  }
  handleDadosCadastrais = (value) => this.props.dadosCadastraisActions.setDadosCadastrais(value);
  handleSuggestionContador = (value) => this.props.dadosCadastraisActions.getSuggestionContador(value);

  handleDataNascimentoCadastral = (name, dados, date) =>
    this.props.dadosCadastraisActions.getDataNascimentoCadastral(name, dados, date);
  handleDataOcorrencia = (name, dados, date) => this.props.dadosCadastraisActions.getDataOcorrencia(name, dados, date);
  handleDataAberturaCadastral = (name, dados, date) =>
    this.props.dadosCadastraisActions.getDataAberturaCadastral(name, dados, date);
  handleModalContador = () => this.props.dadosCadastraisActions.openModalContador(true);
  handleContadorContribuinte = (value) => this.props.dadosCadastraisActions.setContadorContribuinte(value);

  onSubmitModalContador = () => this.props.dadosCadastraisActions.saveContadorContribuinte();

  onCancelModalContador() {
    this.props.dadosCadastraisActions.resetContadorContribuinte();
    this.props.dadosCadastraisActions.openModalContador(false);
  }

  disableAll() {
    const { solicitacao } = this.props.solicitacaoSelector;

    return (
      solicitacao.SituacaoSolicitacao != 1 &&
      solicitacao.SituacaoSolicitacao != 2 &&
      solicitacao.SituacaoSolicitacao != 8
    );
  }

  async onChangeDateTime(name, dados, date) {
    let minDateValue = new Date('01/01/1753');

    //VERIFICA SE A DATA É MAIOR QUE A ATUAL
    if (date > new Date()) {
      var inputDate = document.querySelector(`input[name=${name}]`);
      const result = await _alert.warningPromise(
        `O valor do campo ${dados.Label}  não deve ser maior que a data atual.`,
        'Data inválida.'
      );
      if (result) {
        inputDate.focus();
      }
    }
    //VERIFICA SE A DATA É MENOR QUE A DATA MINIMA '01/01/1753'
    if (date < minDateValue) {
      var inputDate = document.querySelector(`input[name=${name}]`);
      const result = await _alert.warningPromise(
        `O valor do campo ${dados.Label} deve ser maior que a data 01/01/1973.`,
        'Data inválida.'
      );
      if (result) {
        inputDate.focus();
      }
    }
  }

  onChangeContador(value) {
    const { form } = this.props;
    const { dadosCadastrais } = this.props.dadosCadastraisSelector;
    if (value) {
      this.props.dadosCadastraisActions.setDadosCadastrais({
        NomeCadastral: form.values.NomeCadastral ? form.values.NomeCadastral : dadosCadastrais.NomeCadastral,
        NomeFantasiaCadastral: form.values.NomeFantasiaCadastral
          ? form.values.NomeFantasiaCadastral
          : dadosCadastrais.NomeFantasiaCadastral,
        EmailCadastral: form.values.EmailCadastral ? form.values.EmailCadastral : dadosCadastrais.EmailCadastral,
        TelefoneCadastral: form.values.TelefoneCadastral
          ? form.values.TelefoneCadastral
          : dadosCadastrais.TelefoneCadastral,
        CelularCadastral: form.values.CelularCadastral
          ? form.values.CelularCadastral
          : dadosCadastrais.CelularCadastral,
        DataNascimentoCadastral: form.values.DataNascimentoCadastral
          ? form.values.DataNascimentoCadastral
          : dadosCadastrais.DataNascimentoCadastral,
        DataAberturaCadastral: form.values.DataAberturaCadastral
          ? form.values.DataAberturaCadastral
          : dadosCadastrais.DataAberturaCadastral,
        RgIeCadastral: form.values.RgIeCadastral ? form.values.RgIeCadastral : dadosCadastrais.RgIeCadastral,
        Contador: form.values.Contador ? form.values.Contador : dadosCadastrais.Contador,
        EmailContadorCadastral: value.Email ? value.Email : dadosCadastrais.EmailContadorCadastral,

        IdGrupo: form.values.IdGrupo ? form.values.IdGrupo : dadosCadastrais.IdGrupo,
        DescricaoAtividade: form.values.DescricaoAtividade
          ? form.values.DescricaoAtividade
          : dadosCadastrais.DescricaoAtividade,
        DataOcorrencia: form.values.DataOcorrencia ? form.values.DataOcorrencia : dadosCadastrais.DataOcorrencia,

        RegimeTributacaoCadastral: form.values.RegimeTributacaoCadastral
          ? form.values.RegimeTributacaoCadastral
          : dadosCadastrais.RegimeTributacaoCadastral,
      });
    }
  }

  tipoSolicitacao() {
    const { solicitacao } = this.props.solicitacaoSelector;

    return (
      solicitacao.SituacaoSolicitacao != 1 &&
      solicitacao.SituacaoSolicitacao != 2 &&
      solicitacao.SituacaoSolicitacao != 8
    );
  }

  getRegimeTributacao() {
    const { form } = this.props;
    const { deca } = this.props.decaSelector;
    const { registrarSolicitacao } = deca;
    const { parametro } = registrarSolicitacao;

    let itens = [];

    if (this.enableRegimeTributacao(form.values.CpfCnpjSolicitacao)) {
      const semISS = parametro && parametro.find((x) => x.Descricao === 'SemISS' && x.Valor === 'S');

      const bancoCartorio = parametro && parametro.find((x) => x.Descricao === 'BancoCartorio' && x.Valor === 'S');

      const estimado = parametro && parametro.find((x) => x.Descricao === 'Estimado' && x.Valor === 'S');

      const homologado = parametro && parametro.find((x) => x.Descricao === 'Homologado' && x.Valor === 'S');

      const fixo = parametro && parametro.find((x) => x.Descricao === 'Fixo' && x.Valor === 'S');

      if (semISS)
        itens.push({
          Valor: semISS.Codigo,
          Texto: 'Sem Incidência de ISS',
        });

      if (bancoCartorio) itens.push({ Valor: bancoCartorio.Codigo, Texto: 'Banco/Cartório' });

      if (estimado) itens.push({ Valor: estimado.Codigo, Texto: 'Estimado' });

      if (homologado) itens.push({ Valor: homologado.Codigo, Texto: 'Homologado/Variável' });

      if (fixo) itens.push({ Valor: fixo.Codigo, Texto: 'Fixo' });
    }
    return itens;
  }

  render() {
    const { Campos } = DDados;
    let { form, disableAll, retificar } = this.props;
    const { dadosCadastrais } = this.props.dadosCadastraisSelector;
    const { solicitacao } = this.props.solicitacaoSelector;
    const { deca } = this.props.decaSelector;
    const { ComboGrupo } = deca;
    const { telObrigatorio, celObrigatorio } = this.state;

    const encerramentoDesabilita =
      solicitacao.CCM != undefined &&
      (retificar ? solicitacao.TipoSolicitacaoNumero == 3 : solicitacao.TipoSolicitacao == 3);
    disableAll = disableAll
      ? solicitacao.tipoSolicitacaoDisabled
        ? solicitacao.tipoSolicitacaoDisabled
        : disableAll
      : disableAll;

    const desabilitaSolicitacao =
      (!solicitacao.TipoSolicitacao || solicitacao.TipoSolicitacao == 2 || solicitacao.TipoSolicitacao == 3) &&
      !solicitacao.Ccm &&
      this.disableAll();
    return (
      <Fragment>
        <Panel title="Dados da Empresa / Autônomo" expanded={true} expandedFix={true}>
          <Row>
            <Col lg={6}>
              <DDadosItem
                name="NomeCadastral"
                {...Campos.NomeEmpresa}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                Obrigatorio={!encerramentoDesabilita}
                onBlur={(value) => this.handleDadosCadastrais({ NomeCadastral: value })}
              />
            </Col>
            <Col lg={6}>
              <DDadosItem
                name="NomeFantasiaCadastral"
                {...Campos.NomeFantasia}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                onBlur={(value) => this.handleDadosCadastrais({ NomeFantasiaCadastral: value })}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <DDadosItem
                name="EmailCadastral"
                {...Campos.EmailEmpresa}
                state={dadosCadastrais}
                Desabilitado={
                  (!encerramentoDesabilita && disableAll) || this.tipoSolicitacao() || desabilitaSolicitacao
                }
                Obrigatorio={true}
                onBlur={(value) => this.handleDadosCadastrais({ EmailCadastral: value })}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="TelefoneCadastral"
                {...Campos.Telefone}
                state={dadosCadastrais}
                Desabilitado={
                  (!encerramentoDesabilita && disableAll) || this.tipoSolicitacao() || desabilitaSolicitacao
                }
                Obrigatorio={telObrigatorio}
                dynamicMask={'(99) 9999-9999'}
                onChange={(value) => {
                  this.handleDadosCadastrais({ TelefoneCadastral: value });
                  this.verificaTelefone();
                }}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="CelularCadastral"
                {...Campos.Celular}
                state={dadosCadastrais}
                dynamicMask={'(99) 99999-9999'}
                Desabilitado={
                  (!encerramentoDesabilita && disableAll) || this.tipoSolicitacao() || desabilitaSolicitacao
                }
                Obrigatorio={celObrigatorio}
                onChange={(value) => {
                  this.handleDadosCadastrais({ CelularCadastral: value });
                  this.verificaCelular();
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <DDadosItem
                name="DataNascimentoCadastral"
                {...Campos.DataNascimentoEmpresa}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                validateOnBlur
                onBlur={() =>
                  this.handleDataNascimentoCadastral(
                    'DataNascimentoCadastral',
                    Campos.DataNascimentoEmpresa,
                    form.initialValues.DataNascimentoCadastral
                  )
                }
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="RgIeCadastral"
                {...Campos.RgIe}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                onBlur={(value) => this.handleDadosCadastrais({ RgIeCadastral: value })}
                Obrigatorio={!encerramentoDesabilita}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="DataAberturaCadastral"
                {...Campos.DataAberturaEmpresa}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                validateOnBlur
                Obrigatorio={!encerramentoDesabilita}
                onBlur={() =>
                  this.handleDataAberturaCadastral(
                    'DataAberturaCadastral',
                    Campos.DataAberturaEmpresa,
                    form.initialValues.DataAberturaCadastral
                  )
                }
                onChange={() =>
                  this.handleDataAberturaCadastral(
                    'DataAberturaCadastral',
                    Campos.DataAberturaEmpresa,
                    form.initialValues.DataAberturaCadastral
                  )
                }
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                validateOnBlur
                name="DataOcorrencia"
                {...Campos.DataOcorrencia}
                state={dadosCadastrais}
                Desabilitado={
                  (!encerramentoDesabilita && disableAll) || this.tipoSolicitacao() || desabilitaSolicitacao
                }
                Obrigatorio={true}
                onBlur={() =>
                  this.handleDataOcorrencia('DataOcorrencia', Campos.DataOcorrencia, form.initialValues.DataOcorrencia)
                }
                onChange={() =>
                  this.handleDataOcorrencia('DataOcorrencia', Campos.DataOcorrencia, form.initialValues.DataOcorrencia)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <DDadosItem
                name="Contador"
                {...Campos.Contador}
                service={api.suggestionContador}
                state={dadosCadastrais}
                mapItem={(item) => ({ ...item, Exibicao: item.Exibicao })}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                onBlur={(value) => this.handleSuggestionContador(value)}
              />
            </Col>
            <Col>
              <Button
                variant="contained"
                color="primary"
                className={'d-inline mt-4'}
                disabled={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                onClick={() => this.handleModalContador()}
                title={'Cadastrar Contador'}
              >
                <i className={'pointer-events-none fas fa-user'} />
              </Button>
            </Col>
            <Col lg={6}>
              <DDadosItem
                name="EmailContadorCadastral"
                {...Campos.EmailContador}
                state={dadosCadastrais}
                Desabilitado={
                  (!encerramentoDesabilita && disableAll) || this.tipoSolicitacao() || desabilitaSolicitacao
                }
                onBlur={(value) => this.handleDadosCadastrais({ EmailContadorCadastral: value })}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              {dadosCadastrais.RegimeTributacaoErrada ? (
                <DDadosItem
                  name="RegimeTributacaoSolicitacaoDescricao"
                  {...Campos.RegimeTributacaoSolicitacaoDescricao}
                  Desabilitado={true}
                  state={dadosCadastrais}
                  onChange={(value) =>
                    this.handleDadosCadastrais({
                      RegimeTributacaoSolicitacaoDescricao: value,
                    })
                  }
                />
              ) : (
                <DDadosItem
                  name="RegimeTributacaoCadastral"
                  {...Campos.RegimeTributacao}
                  itens={this.getRegimeTributacao()}
                  Desabilitado={
                    !this.enableRegimeTributacao(form.values.CpfCnpjSolicitacao) ||
                    encerramentoDesabilita ||
                    disableAll ||
                    desabilitaSolicitacao
                  }
                  state={dadosCadastrais}
                  Obrigatorio={!encerramentoDesabilita}
                  onChange={(value) =>
                    this.handleDadosCadastrais({
                      RegimeTributacaoCadastral: value,
                    })
                  }
                />
              )}
            </Col>
            <Col lg={6}>
              <DDadosItem
                name="IdGrupo"
                {...Campos.IdGrupo}
                itens={ComboGrupo}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                onChange={(value) => this.handleDadosCadastrais({ IdGrupo: value })}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <DDadosItem
                name="DescricaoAtividade"
                {...Campos.DescricaoAtividade}
                state={dadosCadastrais}
                Desabilitado={encerramentoDesabilita || disableAll || desabilitaSolicitacao}
                Obrigatorio={!encerramentoDesabilita}
                onBlur={(value) => this.handleDadosCadastrais({ DescricaoAtividade: value })}
              />
            </Col>
          </Row>
          <CamposDinamicos isView={encerramentoDesabilita || disableAll} />
        </Panel>
        <ModalContador
          onSubmit={this.onSubmitModalContador}
          onCancel={this.onCancelModalContador}
          openClose={dadosCadastrais.openModalContador}
          state={dadosCadastrais.ContadorContribuinte}
          onChange={(value) => this.handleContadorContribuinte(value)}
        />
      </Fragment>
    );
  }
}

export default connect({
  selectors: {
    decaSelector,
    dadosCadastraisSelector,
    solicitacaoSelector,
  },
  actions: {
    dadosCadastraisActions,
    contadorActions,
  },
})(Container);
